import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Tooltip,Button,Popover,message,Modal, Tag} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import moment from "moment";

class DeviceBusinessList extends ListPage {
    constructor(props) {
        super(props);
    }

    base_getListConfig() {
        return {
            table: {
                title: false,
                columns: this.getTableColumns(),
                url: APILXD.businessGetDeviceList,
                otherParam: {
                    ...this.props.pageParams
                }
            },
        }
    }

    /**
     *  列表数据配置
     */
    getTableColumns() {
        return [
            {
                title: '设备号',
                dataIndex: '_id',
                key: '_id',
                render: (text,record)=>{
                    return <div>
                        <div>设备ID：{text}</div>
                        <div>ROMID：{record.romId}</div>
                    </div>
                }
            },
            {
                title: '机型',
                dataIndex: 'type',
                key: 'type',
                render: (text, record, index) => {
                    let name = "未知";
                    switch (text) {
                        case 2:
                            name = "手机";
                            break;
                        case 3:
                            name = "PC";
                            break;
                        case 4:
                            name = "服务器";
                            break;
                        default:
                            name = "未知";
                    }
                    return <div>
                        {name}
                    </div>
                }
            },
            {
                title: '绑定状态',
                dataIndex: 'bindStatus',
                key: 'bindStatus',
                render: (_, record) => {
                    switch (record.bindStatus) {
                        case 1:
                            return  <Tag color="green">
                                已绑定
                            </Tag>;
                        case 2:
                            return <Tag color="red">未绑定</Tag>;
                    }
                },
            },
            {
                title: '工作状态',
                dataIndex: 'status',
                key: 'status',
                render: (text) => {
                    let map = {
                        "1": {text: "缺勤", color: "red"},
                        "2": {text: "空闲", color: "green"},
                        "3": {text: "忙碌", color: "dodgerblue"},
                    };
                    let statusMap = map[text + ""];
                    if (!statusMap) {
                        statusMap = {text: "未知", color: "red"}
                    }
                    return <span style={{color: statusMap.color}}>{statusMap.text}</span>
                }
            },
            {
                title: '数字人分身数',
                dataIndex: 'robotCount',
                key: 'robotCount',
            },
            {
                title: 'IP',
                dataIndex: 'ips',
                key: 'ips_ip',
                ellipsis: true,
                render: (_, record) => {
                    if (record.ips && record.ips.length > 0) {
                        return record.ips.map((item) => item.ip).join(',');
                    }
                    return '-';
                },
            },
            {
                title: 'ESIM/SIM',
                dataIndex: 'mobiles',
                key: 'mobiles',
                render: (_, record) => {
                    return record.mobiles ? record.mobiles?.map((i) => i).join(',') : `-`;
                },
            },
            {
                title: '系统',
                dataIndex: 'romId',
                key: 'romId',
            },
            {
                title: '添加时间',
                dataIndex: 'addTime',
                key: 'addTime',
                render: (text, record, index) => {
                    return  <div>{record.addTime ? TimeHelp.getYMDHM(record.addTime) : "-"}</div>
                }
            },
            {
                title: '最后请求信息',
                dataIndex: 'location',
                key: 'location',
                render: (text, record, index) => {
                    let countryName = text && text.countryName ? (text.countryName + " ") : "";
                    let provinceName = text && text.provinceName ? (text.provinceName + " ") : "";
                    let cityName = text && text.cityName || "";
                    return <div>
                        <div>IP：{record.ip}</div>
                        <div>地点：{
                          countryName + provinceName + cityName
                        }
                        </div>
                    </div>
                }
            },
            {
                title: '最后请求时刻',
                dataIndex: 'lastTime',
                key: 'lastTime',
                render: (text,record) => {
                    return <div>
                        <div>{text ? <Tooltip
                            title={TimeHelp.getYMDHM(text)}
                        >{moment(text).fromNow()}</Tooltip> : "-"}</div>
                    </div>
                }
            },

        ]
    }
}

module.exports = DeviceBusinessList;